
// src/components/coverLetter/CoverLetter.js
import React from 'react';
import './coverLetter.css'; // Create this CSS file for styling

const CoverLetter = () => {
  return (
    <div className="cover-letter">
      <h1>Hello Recruiters!</h1>
      <p>
      I'm Prashant, a passionate and experienced Data Analyst with a proven track record in SQL, Power BI, Excel, and Python (including Numpy, Pandas, Matplotlib, and Seaborn). My diverse experience and commitment to excellence have enabled me to deliver impactful insights and innovative solutions across various data-driven projects.
      </p>
      <p>
      Throughout my career, I have consistently demonstrated my ability to handle complex data analysis tasks, including developing comprehensive dashboards, performing exploratory data analysis, and implementing machine learning models. Noteworthy accomplishments include streamlining customer support systems at Five S Digital, predicting Titanic survival rates, and analyzing hotel sales data to enhance revenue strategies.
      </p>
      <p>
      I thrive in collaborative environments where I can leverage my skills in data visualization, statistical analysis, and machine learning to solve real-world problems and drive meaningful change. I am particularly excited about opportunities that allow me to lead impactful projects, work with cutting-edge technologies, and contribute to a dynamic team.
      </p>
      <p>
      I invite you to explore my portfolio to view some of my recent work and learn more about my professional journey. Thank you for visiting my site. I look forward to discussing how my background, skills, and enthusiasm align with the goals of your organization.
      </p>
      <p>
        Best regards,<br />
        Prashant Singh
      </p>
    </div>
  );
};

export default CoverLetter;
